import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const DISCHARGE_PATH = 'dischargeInformation'

//#region Detail
export function getDischargeByUser(userId, id) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/${DISCHARGE_PATH}/getByUserId`, {
            params: {
                userId,
                id,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

//#endregion

//#region Create Or Update
export function createOrUpdateDischarge(userId, data) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${DISCHARGE_PATH}/createOrUpdate`, data, {
            params: {
                userId,
            },
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region Discharge Patient

//#endregion
